module.exports = __webpack_public_path__ + "aa778b29fa1fb7eeacc56f1cf6161fbd.pdf";